import { MutationTuple, useMutation } from '@apollo/client';
import { RejectFitupRequestInput, RejectFitupPayload } from '@bechtel/types';
import { REJECT_FITUP_REQUEST } from '@bechtel/client-gql';

export function useRejectFitupRequest(
  onActionCompleted?: () => void,
  refetchQueries?: string[]
): MutationTuple<{ rejectFitupPayload: RejectFitupPayload }, { input: RejectFitupRequestInput }> {
  const response = useMutation<{ rejectFitupPayload: RejectFitupPayload }, { input: RejectFitupRequestInput }>(
    REJECT_FITUP_REQUEST,
    {
      notifyOnNetworkStatusChange: true,
      onCompleted: () => {
        if (onActionCompleted) onActionCompleted();
      },
      onError: () => {
        if (onActionCompleted) onActionCompleted();
      },
      refetchQueries,
    }
  );
  return response;
}
